module.exports = __webpack_public_path__ + "img/hr-green-croton-09.6cf8d7fb.png";